import {
  AccordionProps,
  Grid2 as Grid,
  Grid2Props as GridProps,
  styled,
  TextFieldProps
} from '@mui/material'
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker'
import AccordionBase from 'components/Accordion'
import NumberInput, { NumberInputProps } from 'components/InputMask'
import SelectBox, { SelectBoxProps } from 'components/SelectBox'
import SwitchButtons, { SwitchButtonsProps } from 'components/SwitchButton'
import { Dayjs } from 'dayjs'
import InputBase from 'design-system/input/base'
import React from 'react'

export const StyledAccordionBase = styled(AccordionBase)(({ theme }) => ({
  background: theme.palette.tabBorder.main,
  boxShadow: 'none',
  border: `1px solid ${theme.palette.divider}`,
  margin: '0 !important'
}))

type SameOptions = {
  id: string
  containerProps: GridProps
  hidden?: boolean
}

export type Field = (
  | { type: 'select'; fieldProps: SelectBoxProps }
  | { type: 'date'; fieldProps: DatePickerProps<Dayjs, boolean> }
  | { type: 'text'; fieldProps: TextFieldProps }
  | { type: 'number'; fieldProps: NumberInputProps }
  | { type: 'switch-btn'; fieldProps: SwitchButtonsProps }
  | { type?: null; fieldProps?: null; children?: React.JSX.Element }
) &
  SameOptions

export interface AccordionFormProps {
  fields?: Array<Field>
  hidden?: boolean
  id: string
  title: string
  accordionProps?: Omit<AccordionProps, 'children'>
}

const AccordionForm: React.FC<AccordionFormProps> = ({
  fields,
  id,
  title,
  accordionProps,
  hidden = false
}) => {
  if (hidden) return null

  const handleField = (item: Field) => {
    // TODO: usar switch > case
    if (item.type == undefined) {
      return item.children
    }
    if (item.type === 'select') {
      return <SelectBox {...item.fieldProps} />
    }
    if (item.type === 'date') {
      return <DatePicker {...item.fieldProps} />
    }
    if (item.type === 'text') {
      return <InputBase {...item.fieldProps} />
    }
    if (item.type === 'switch-btn') {
      return <SwitchButtons {...item.fieldProps} />
    }
    if (item.type === 'number') {
      return <NumberInput {...item.fieldProps} />
    }
    return 'unknown'
  }

  return (
    <StyledAccordionBase title={title} {...accordionProps}>
      <Grid container spacing={3}>
        {fields
          ?.filter(item => !item.hidden)
          .map((item, index) => (
            <Grid {...item.containerProps} key={`${id}-${index}`}>
              {handleField(item)}
            </Grid>
          ))}
      </Grid>
    </StyledAccordionBase>
  )
}

export default AccordionForm
